import {
  IBitrixDeal,
  IBitrixDealsInDealPlacement,
} from 'src/store/crosstable/reducer';
import { useMemo } from 'react';
import { canWrite } from 'src/accessControl';

export const useBitrixPlacementDeal = (placement?: IBitrixDeal | IBitrixDealsInDealPlacement | null) => {
  const isUnitCanBeUnLinked = useMemo(() => {
    // Unlinking is a value->null write on the deal's `placement`;
    // a missing rule entry means "no restrictions".
    return canWrite(placement?.['@accessRules'], 'placement', 'value_to_null_blocked');
  }, [placement]);
  return {
    isUnitCanBeUnLinked,
  };
};
